import '../styles/pages/legal.css'

function PrivacyPolicy() {
  return (
    <div className="legal-page">
      <div className="legal-content">
        <h1>Privatlivspolitik</h1>
        <p className="last-updated">Sidst opdateret: {new Date().toLocaleDateString('da-DK')}</p>

        <section>
          <h2>1. Data Controller</h2>
          <p>
            Parkort<br />
            Email: info@thomasvalenzuela.com<br />
            (Tilføj din adresse og CVR nummer hvis relevant)
          </p>
        </section>

        <section>
          <h2>2. Hvilke Data Indsamles</h2>
          <p>Vi indsamler følgende data når du bruger Parkort:</p>
          <ul>
            <li><strong>Præferencer og svar:</strong> De emner du vælger og de svar du giver</li>
            <li><strong>Booking information:</strong> Eventuelle foreslåede tidspunkter eller deadlines</li>
            <li><strong>Teknisk data:</strong> IP-adresse, browser type, enhedstype (via server logs)</li>
          </ul>
          <p><strong>Vigtigt:</strong> Vi gemmer ingen data permanent. Alle data er midlertidige og kun tilgængelige via delte links.</p>
        </section>

        <section>
          <h2>3. Formål med Databehandling</h2>
          <p>Vi behandler dine data for at:</p>
          <ul>
            <li>Levere Parkort tjenesten (oprette kort, dele links, beregne match scores)</li>
            <li>Forbedre tjenesten gennem anonymiseret analyse</li>
            <li>Håndtere betalinger (hvis du vælger Premium)</li>
          </ul>
        </section>

        <section>
          <h2>4. Legal Basis</h2>
          <p>Vi behandler dine data baseret på:</p>
          <ul>
            <li><strong>Samtykke (GDPR art. 6(1)(a)):</strong> Du giver samtykke ved at bruge tjenesten</li>
            <li><strong>Kontraktudførelse (art. 6(1)(b)):</strong> For at levere tjenesten du har anmodet om</li>
          </ul>
        </section>

        <section>
          <h2>5. Modtagere af Data</h2>
          <p>Dine data kan deles med:</p>
          <ul>
            <li><strong>Hosting provider:</strong> Til at hoste tjenesten</li>
            <li><strong>Payment processor (Stripe):</strong> Hvis du vælger Premium, håndterer Stripe betalingsdata</li>
            <li><strong>Den person du deler linket med:</strong> De kan se de emner og svar du deler</li>
          </ul>
        </section>

        <section>
          <h2>6. Opbevaringstid</h2>
          <p>
            <strong>Kort data:</strong> Indtil linket slettes eller efter 12 måneders inaktivitet<br />
            <strong>Response data:</strong> Indtil linket slettes eller efter 12 måneders inaktivitet<br />
            <strong>Server logs:</strong> 30 dage<br />
            <strong>Betalingsdata:</strong> 7 år (skattemæssige krav)
          </p>
        </section>

        <section>
          <h2>7. Dine Rettigheder</h2>
          <p>Du har følgende rettigheder under GDPR:</p>
          <ul>
            <li><strong>Ret til indsigt (art. 15):</strong> Du kan anmode om at se hvilke data vi har om dig</li>
            <li><strong>Ret til berigtigelse (art. 16):</strong> Du kan anmode om rettelse af forkerte data</li>
            <li><strong>Ret til sletning (art. 17):</strong> Du kan anmode om sletning af dine data</li>
            <li><strong>Ret til begrænsning (art. 18):</strong> Du kan anmode om begrænsning af behandling</li>
            <li><strong>Ret til dataportabilitet (art. 20):</strong> Du kan anmode om at få dine data i et struktureret format</li>
            <li><strong>Ret til indsigelse (art. 21):</strong> Du kan gøre indsigelse mod behandling</li>
          </ul>
          <p>For at udøve dine rettigheder, kontakt os på: <a href="mailto:info@thomasvalenzuela.com">info@thomasvalenzuela.com</a></p>
        </section>

        <section>
          <h2>8. Sikkerhed</h2>
          <p>
            Vi tager sikkerhed alvorligt og bruger:
          </p>
          <ul>
            <li>HTTPS encryption for al data i transit</li>
            <li>Sikker betaling via Stripe (PCI DSS compliant)</li>
            <li>Begrænset adgang til data</li>
            <li>Regelmæssige sikkerhedsopdateringer</li>
          </ul>
        </section>

        <section>
          <h2>9. Cookies</h2>
          <p>
            Vi bruger kun nødvendige cookies til at levere tjenesten. Se vores <a href="/cookie-policy">Cookiepolitik</a> for mere information.
          </p>
        </section>

        <section>
          <h2>10. Kontakt</h2>
          <p>
            Hvis du har spørgsmål til denne privatlivspolitik eller vores behandling af dine data, kontakt os på:<br />
            <strong>Email:</strong> <a href="mailto:info@thomasvalenzuela.com">info@thomasvalenzuela.com</a>
          </p>
        </section>

        <section>
          <h2>11. Opdateringer</h2>
          <p>
            Vi kan opdatere denne privatlivspolitik fra tid til anden. Vi vil informere dig om væsentlige ændringer via email eller via en notifikation på hjemmesiden.
          </p>
        </section>
      </div>
    </div>
  )
}

export default PrivacyPolicy
